import type {GatewayError} from '@yandex-data-ui/gateway';

import {WikiSearchData} from '~shared/models/wiki';
import {getInitialSearchState} from '~shared/utils';

import {SearchQueryParams} from './types';

export interface SearchState {
    params: SearchQueryParams;
    data?: WikiSearchData;
    status:
        | 'initial'
        | 'search-loading'
        | 'page-loading'
        | 'loaded'
        | 'search-error'
        | 'page-error';
    error?: GatewayError;
}

export const initialState: SearchState = getInitialSearchState();
